import axios from 'axios';
import React, { useEffect } from 'react';
import * as THREE from "three";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import SideStyle from '../style/sideStyle';
import Control from '../store/control';
import Param from '../store/param';
// import { Start, Check, GetSTL, GetLog } from "../fileIO/post";
import { Vpoints2Array } from "../shape/Adapter";
import { GetTrim3D } from '../shape/Trim';
import { AddIcon } from './formUtil';
// import { POLLING_INTERVAL1, POLLING_INTERVAL10 } from '../store/global';
import { toast } from 'react-toastify';


const FormTrim1 = () => {
  const style          = SideStyle();
  const trim           = Param.Get("trim");
  const trim1           = Param.Get("trim1");
  // const modify         = Param.Get("modify");
  const setParam       = Param.Get("setParam");
  const setControl     = Control.Get("setControl");
  // const meshSocketF11  = Control.Get("meshSocketF11");
  const meshSocketModify = Control.Get("meshSocketModify");
  const meshSocketModifyVtk = Control.Get("meshSocketModifyVtk");
  const SetCameraIn    = Control.Get("SetCameraIn");

  // const [p0y, setP0y] = React.useState(trim1.medialTrimPoints[0].z);
  // const [p0z, setP0z] = React.useState(trim1.medialTrimPoints[0].y);
  // const [p1y, setP1y] = React.useState(trim1.medialTrimPoints[1].z);
  // const [p1z, setP1z] = React.useState(trim1.medialTrimPoints[1].y);
  // const [p2y, setP2y] = React.useState(trim1.medialTrimPoints[2].z);
  // const [p2z, setP2z] = React.useState(trim1.medialTrimPoints[2].y);
  // const [p3y, setP3y] = React.useState(trim1.medialTrimPoints[3].z);
  // const [p3z, setP3z] = React.useState(trim1.medialTrimPoints[3].y);

  // useEffect(() => {
  //   setP0y(trim1.medialTrimPoints[0].z);
  //   setP0z(trim1.medialTrimPoints[0].y);
  //   setP1y(trim1.medialTrimPoints[1].z);
  //   setP1z(trim1.medialTrimPoints[1].y);
  //   setP2y(trim1.medialTrimPoints[2].z);
  //   setP2z(trim1.medialTrimPoints[2].y);
  //   setP3y(trim1.medialTrimPoints[3].z);
  //   setP3z(trim1.medialTrimPoints[3].y);
  // }, [trim1.medialTrimPoints]);

  useEffect(() => {
    SetCameraIn()
    toast("Edit the projectoin curve, and push [Applying to 3D curve].");
  }, []);

  const handleValue = (e) => {
    setParam(s => {s.trim1[e.target.name] = Number(e.target.value)});
  };

  useEffect(() => {
    setControl(s => {s.flgLegClickable = false, s.flgSocketClickable = false});
  });

  return (
    <div className={style.outside}>
      <Grid container spacing={1} alignItems='center'>
        
        <TextField
          id='filled-number'
          name='p0Y'
          label='P0 SI'
          type='number'
          // defaultValue={p0y}
          value={trim1.p0Y}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 'mm',
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-500,
            max:500,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          name='p0Z'
          label='P0 AP'
          type='number'
          // defaultValue={p0z}
          value={trim1.p0Z}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 'mm',
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-500,
            max:500,
            step:1
          }}
        />

        <TextField
          id="filled-number"
          name='p1Y'
          label="P1 SI"
          type="number"
          // defaultValue={p1y}
          value={trim1.p1Y}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 'mm',
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-500,
            max:500,
            step:1
          }}
        />

        <TextField
          id="filled-number"
          name='p1Z'
          label="P1 AP"
          type="number"
          // defaultValue={p1z}
          value={trim1.p1Z}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 'mm',
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-500,
            max:500,
            step:1
          }}
        />

        <TextField
          id="filled-number"
          name='p2Y'
          label="P2 SI"
          type="number"
          // defaultValue={p2y}
          value={trim1.p2Y}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 'mm',
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-500,
            max:500,
            step:1
          }}
        />
        <TextField
          id="filled-number"
          name='p2Z'
          label="P2 AP"
          type="number"
          // defaultValue={p2z}
          value={trim1.p2Z}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 'mm',
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-500,
            max:500,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          name='p3Y'
          label='P3 SI'
          type='number'
          // defaultValue={p3y}
          value={trim1.p3Y}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 'mm',
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-500,
            max:500,
            step:1
          }}
        />
        <TextField
          id="filled-number"
          name='p3Z'
          label="P3 AP"
          type="number"
          // defaultValue={p3z}
          value={trim1.p3Z}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 'mm',
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-500,
            max:500,
            step:1
          }}
        />
      
      </Grid>
    </div>
  );
}
export default FormTrim1;
